import { Col, Form, Input, Row } from 'antd';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { EnrollmentFormContext } from '../../../../../../../../../providers/EnrollmentFormContextProvider';
import InputNumber from '../../../../../../../../../components/form/inputs/InputNumber';
import InputGeo from '../../../../../../../../../components/common/inputs/InputGeo';

const messageRequiredData = 'Dato requerido';

const Address = ({ gutter, title, index }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  return (
    <>
      <Row>
        <Col span={24}>
          <p className="personalDocumentsForm__title">{title}</p>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col lg={24} xs={24}>
          <InputGeo
            form={enrollmentForm}
            countryName={['legalRepresentatives', index, 'particularAddress', 'country']}
            regionName={['legalRepresentatives', index, 'particularAddress', 'region']}
            cityName={['legalRepresentatives', index, 'particularAddress', 'city']}
            required
          />
        </Col>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'particularAddress', 'streetName']}
            label="Calle/Avenida"
            rules={[{ required: true, message: messageRequiredData }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col lg={6} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'particularAddress', 'streetNumber']}
            label="Número"
            rules={[{ required: true, message: messageRequiredData }]}
          >
            <InputNumber hideArrows />
          </Form.Item>
        </Col>
        <Col lg={6} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'particularAddress', 'houseNumber']}
            label="Depto/Casa"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

Address.propTypes = {
  gutter: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
};

export default Address;
